<template>
  <div>
    <event-notification style="position: relative;"></event-notification>
    <!-- <dashboard-seller v-if="isSeller || isManager"></dashboard-seller> -->
    <dashboard-admin v-if="isAdmin || isSectorManager"></dashboard-admin>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DashboardAdmin from './dashboard-admin/DashboardAdmin'
  import DashboardSeller from './DashboardSeller'
  import DashboardOperator from './DashboardOperator'

  export default {
    name: 'AppHome',
    components: {DashboardAdmin, DashboardSeller, DashboardOperator},
    data () {
      return {}
    },
    computed: {
      ...mapGetters([
        'currentUserPk', 'isAdmin', 'isManager', 'isSeller', 'isOperator', 'isSectorManager'
      ])
    },
    methods: {},
    watch: {
      currentUserPk (v) {
        if (v && !this.isAdmin) {
          this.$router.replace({name: 'StockPrograms'})
        }
      }
    },
    mounted () {
      if (this.isOperator) {
        this.$router.push({name: 'CalendarMonthView'})
      } else if (this.currentUserPk && !this.isAdmin) {
        this.$router.replace({name: 'StockPrograms'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/AppHome.vue